ModalTrigger =
  show:(selector) ->
    $(selector).trigger 'show.bs.modal'
    $(selector).trigger 'shown.bs.modal'

LP.module('ModalTrigger', ModalTrigger)
